<template>
  <div class="content">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <span v-if="dominItem.templateId === 'temp3'" style="font-size: 20px">{{ dominItem.logoName || 'Logo' }}</span>
      <div>
        <span>{{ nowDate }}</span>
        <span @click="changeType(1)">{{ $t('con_home') }}</span>
        <span @click="changeType(1)">{{ $t('con_about') }}</span>
      </div>
    </div>
    <div style="padding: 0 20px">
      <div :style="{marginTop: dominItem.templateId === 'temp3' ? '30px' : ''}">
        <div class="logo" v-if="dominItem.templateId !== 'temp3'" :class="[dominItem.templateId ? 'logo-' + dominItem.templateId : '']">
          {{ dominItem.logoName || 'Logo' }}
        </div>
        <div class="category">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
      </div>



      <div class="content-hot" v-if="bestInfo">
        <div style="text-align: center;">
          <img @click="toDetail(bestInfo.articleShortName)"
               :src="bestInfo.articleImage || defaultImg"
               alt="">
        </div>
        <h2 class="title" @click="toDetail(bestInfo.articleShortName)">
          {{ bestInfo.articleTitle }}
        </h2>
<!--        <div class="post-meta">-->
<!--          <span class="country">{{ $t('con_time')}}</span>-->
<!--          <span class="ring"></span>-->
<!--          <span>{{ bestInfo.uploadTime }}</span>-->
<!--        </div>-->

        <div class="post-summary">
          {{ bestInfo.articleIntro }}
        </div>

        <div class="readmore" @click="toDetail(bestInfo.articleShortName)">
          <!--          READ MORE-->
          {{ $t('con_read_more') }}
        </div>

        <div class="post-list">
          <div v-for="(item, index) in articleList">
            <template v-if="index < 4">
              <div class="bot-img">
                <img @click="toDetail(item.articleShortName)" :src="item.articleImage || defaultImg" alt="">
              </div>
              <span class="title" @click="toDetail(item.articleShortName)">{{ item.articleTitle }}</span>
<!--              <div class="time">-->
<!--                {{ item.uploadTime }}-->
<!--              </div>-->
            </template>
          </div>
        </div>
      </div>


      <div class="last-news">
        <div class="category">
          <!--          -->
          <span style="padding: 0">{{ $t('con_latest')}}</span>
        </div>

        <div class="last-news-content">
          <div v-for="item in latestNewsList"
               style="display: flex; justify-content: space-between;
                padding-bottom: 30px; border-bottom: 1px solid #D9D9D9; padding-top: 30px">
            <div class="imgbox">
              <img :src="item.articleImage || defaultImg" alt="">
            </div>
            <div class="last-news-content-box">
              <span class="threenum">{{ item.articleTitle }}</span>
              <span class="threenum" style="margin: 10px 0">{{ item.articleIntro }}</span>
              <div class="readmore" @click="toDetail(item.articleShortName)">
                {{ $t('con_read_more') }}
                <!--                READ MORE...-->
              </div>
            </div>
          </div>
        </div>
        <van-pagination
            v-model="newsPageNum"
            :total-items="newsTotal"
            @change="getLatestNewsList"
            :items-per-page="5"
            :prev-text="$t('con_PREV')"
            :next-text="$t('con_NEXT')"
            :show-page-size="5"
            force-ellipses
        />
      </div>

      <div class="last-news cat-news">
        <div class="category">
          <span style="padding: 0">{{ $t('con_recommend') }}</span>
        </div>

        <div class="last-news-content">
          <div v-for="item in recommendList" class="content-box" @click="toDetail(item.articleShortName)">
            <div class="bot-img">
              <img :src="item.articleImage || defaultImg" alt="">
            </div>
            <div class="last-news-content-box">
              <span class="title">{{ item.articleTitle }}</span>
            </div>
            <div class="post-meta">
              <span class="country">{{ $t('con_time') }}</span>
<!--              <span class="ring"></span>-->
<!--              <span>{{ item.uploadTime }}</span>-->
            </div>
          </div>
        </div>
      </div>
      <van-pagination
          v-model="recommendPageNum"
          :total-items="recommendTotal"
          @change="getRecommendList"
          :items-per-page="6"
          :prev-text="$t('con_PREV')"
          :next-text="$t('con_NEXT')"
          :show-page-size="5"
          force-ellipses
      />
    </div>
    <div class="footer">
      <span style="font-size: 50px; color: #ffffff">{{ dominItem.logoName || 'Logo' }}</span>
      <div class="icon-box"  v-if="dominItem.nationId !== 'cn'">
        <div v-for="item in iconList" @click="openLink(item.link)">
        <img :src="item.url" alt="">
        </div>
      </div>
      <div class="category foot-cate">
        <span v-for="item in typeList" @click="changeType(item.id)">{{ item.label }}</span>
      </div>
      <span>© 2023 - {{ dominItem.logoName || 'Logo' }}. All Rights Reserved. Website: {{ dominItem.logoName || 'Logo' }}</span>
    </div>

  </div>
</template>
<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName} from "@/api"
import {format} from 'date-fns'
import Clipboard from 'clipboard';

export default {
  props: {
    dominItem: Object
  },
  data() {
    return {
      current: 1,
      clipboardText: window.location.href,
      currentPage: 1,
      nodata: false,
      defaultImg: undefined,
      iconList: [
        {url: require('../../assets/icon1.svg'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon2.svg'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon3.svg'), link: 'https://www.google.com/'},
        {url: require('../../assets/icon4.svg'), link: 'https://www.instagram.com/'},
        {url: require('../../assets/icon5.svg'), link: 'mailto:#'},
        {url: require('../../assets/icon6.svg'), link: 'https://www.youtube.com/'},
      ],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
      articleList: [],
      latestNewsList: [],
      recommendList: [],
      newsPageNum: 1,
      newsTotal: undefined,
      recommendPageNum: 1,
      recommendTotal: undefined,
      bestInfo: undefined,

    };
  },

  created() {
    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    }
    this.defaultImg = JSON.parse(localStorage.getItem('dominItem')).defaultImg

    this.nowDate = format(new Date(), this.$t('con_format'))
  },

  methods: {
    openLink(link) {
      window.open(link)
    },

    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getOneList()
    },
    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        this.bestInfo = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取文章列表
    getArticleList() {
      this.nodata = true
      getContentList({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        this.articleList = res.rows
        this.articleList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
        this.nodata = false
      })
    },

    // 获取最后次更新的文章
    getLatestNewsList() {
      getLatestNews({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 5, articleNationId: this.dominItem.nationId}).then(res => {
        this.latestNewsList = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取推荐的文章
    getRecommendList() {
      getRecommend({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 6, articleNationId: this.dominItem.nationId}).then(res => {
        this.recommendList = res.rows
        this.recommendTotal = res.total
        this.recommendList.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        })
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  },
};
</script>
<style lang="scss" scoped>
@import "en";
</style>
